import React, { useMemo } from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { MdClose } from 'react-icons/md';
import styled from 'styled-components';
import media from 'styled-media-query';

import { State } from 'src/state/ducks';
import SingleInputFormBlock from 'src/components/molecules/form/SingleInputFormBlock';
import InputLabelHolder from 'src/components/molecules/form/InputLabelHolder';
import SelectBox from 'src/components/atoms/form/SelectBox';
import { ValidateMessageIfError } from 'src/components/atoms/form/ErrorMessage';

type Props = {
  id: string;
  name: string;
  order: number;
  isFeatured: boolean;
  isDisabled: boolean;
  onChangeName: (order: number, name: string) => void;
  onChangeRadio: (key: 'isFeatured' | 'isDisabled', order: number, bool: boolean) => void;
  onDelete: (order: number) => void;
  errors?: State['bakedBreadTag']['validationErrors'];
};

const BakedBreadTagForm = SortableElement((props: Props) => {
  const { name, order, isFeatured, isDisabled, onChangeName, onChangeRadio, onDelete } = props;

  const isFeaturedValue = useMemo(() => (isFeatured ? 'する' : 'しない'), [isFeatured]);
  const isDisabledValue = useMemo(() => (isDisabled ? 'する' : 'しない'), [isDisabled]);

  const options = useMemo(
    () => [
      { value: 'しない', content: 'しない' },
      { value: 'する', content: 'する' },
    ],
    [],
  );

  return (
    <Container>
      <div className="item">
        <SingleInputFormBlock
          isRequired={true}
          labelName="タグ名"
          inputType="text"
          inputValue={name}
          placeholder=""
          onChange={(name) => onChangeName(order, name)}
          isError={false}
          isDisabeld={false}
        />
      </div>
      <div className="item">
        <InputLabelHolder labelName="カテゴリ表示" isRequired={false} />
        <SelectBox
          id="isFeatured"
          placeholder=""
          inputValue={isFeaturedValue}
          onChange={(value) => onChangeRadio('isFeatured', order, value === 'する')}
          options={options}
          disabled
        />
      </div>
      <div className="item">
        <InputLabelHolder labelName="非表示" isRequired={false} />
        <SelectBox
          id="isDisabled"
          placeholder=""
          inputValue={isDisabledValue}
          onChange={(value) => onChangeRadio('isDisabled', order, value === 'する')}
          options={options}
        />
      </div>
      <MdClose className="button-close" size={24} onClick={() => onDelete(order)} />
      <ValidateMessageIfError marginVertical={8} messages={[]} />
    </Container>
  );
});

const Container = styled.div`
  background: #fff;
  padding: 16px;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  z-index: 9999;

  .item {
    &:first-child {
      width: 50%;
      ${media.lessThan('medium')`
        width: 100%;
        margin-bottom: 12px;
      `};
    }
    &:not(:first-child) {
      width: 20%;
      ${media.lessThan('medium')`
        width: 40%;
      `};
    }
  }

  .button-close {
    display: none;
  }
`;

export default BakedBreadTagForm;
